import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import md5 from "md5";
import request from "./request";
export function login(_x) { return _login.apply(this, arguments); }
function _login() { _login = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(data) { var resp; return _regeneratorRuntime.wrap(function _callee$(_context) { while (1) {
    switch (_context.prev = _context.next) {
        case 0:
            _context.next = 2;
            return request.post("/api/v1/online/login/ajaxLogin", Object.assign({}, data, { password: data.password ? md5(data.password) : null, inlineError: true }));
        case 2:
            resp = _context.sent;
            return _context.abrupt("return", resp.data);
        case 4:
        case "end": return _context.stop();
    }
} }, _callee); })); return _login.apply(this, arguments); }
export function verifyOtp(_x2) { return _verifyOtp.apply(this, arguments); }
function _verifyOtp() { _verifyOtp = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(data) { var resp; return _regeneratorRuntime.wrap(function _callee2$(_context2) { while (1) {
    switch (_context2.prev = _context2.next) {
        case 0:
            _context2.next = 2;
            return request.post("/api/v1/online/login/verifyLoginOtp", Object.assign({}, data, { useSubmitTime: true, inlineError: true }));
        case 2:
            resp = _context2.sent;
            return _context2.abrupt("return", resp.data);
        case 4:
        case "end": return _context2.stop();
    }
} }, _callee2); })); return _verifyOtp.apply(this, arguments); }
export function checkLogin(_x3) { return _checkLogin.apply(this, arguments); }
function _checkLogin() { _checkLogin = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3(language) { var _languageMap$language; var languageMap, resp, userKey; return _regeneratorRuntime.wrap(function _callee3$(_context3) { while (1) {
    switch (_context3.prev = _context3.next) {
        case 0:
            languageMap = { en: "en_US", hk: "zh_HK", cn: "zh_CN" };
            _context3.next = 3;
            return request.post("/api/v1/online/login/checkLogin", { useSubmitTime: true, request_locale: (_languageMap$language = languageMap[language]) !== null && _languageMap$language !== void 0 ? _languageMap$language : language });
        case 3:
            resp = _context3.sent;
            userKey = localStorage.getItem("customerIDHit");
            if (resp.data.data.userId !== null) {
                localStorage.setItem("customerIDHit", resp.data.data.userId);
            }
            else if (userKey !== null) {
                localStorage.removeItem("customerIDHit");
            }
            return _context3.abrupt("return", resp.data);
        case 7:
        case "end": return _context3.stop();
    }
} }, _callee3); })); return _checkLogin.apply(this, arguments); }
export function logout() { return _logout.apply(this, arguments); }
function _logout() { _logout = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee4() { var resp, userKey; return _regeneratorRuntime.wrap(function _callee4$(_context4) { while (1) {
    switch (_context4.prev = _context4.next) {
        case 0:
            _context4.next = 2;
            return request.post("/api/v1/online/login/logout");
        case 2:
            resp = _context4.sent;
            userKey = localStorage.getItem("customerIDHit");
            if (userKey !== null) {
                localStorage.removeItem("customerIDHit");
            }
            return _context4.abrupt("return", resp.data);
        case 6:
        case "end": return _context4.stop();
    }
} }, _callee4); })); return _logout.apply(this, arguments); }
export function checkForgotUsername(_x4) { return _checkForgotUsername.apply(this, arguments); }
function _checkForgotUsername() { _checkForgotUsername = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee5(data) { var resp; return _regeneratorRuntime.wrap(function _callee5$(_context5) { while (1) {
    switch (_context5.prev = _context5.next) {
        case 0:
            _context5.next = 2;
            return request.post("/api/v1/online/login/checkForgotUsername", Object.assign({}, data, { useSubmitTime: true, inlineError: true }));
        case 2:
            resp = _context5.sent;
            return _context5.abrupt("return", resp.data);
        case 4:
        case "end": return _context5.stop();
    }
} }, _callee5); })); return _checkForgotUsername.apply(this, arguments); }
export function checkForgotPassword(_x5) { return _checkForgotPassword.apply(this, arguments); }
function _checkForgotPassword() { _checkForgotPassword = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee6(data) { var resp; return _regeneratorRuntime.wrap(function _callee6$(_context6) { while (1) {
    switch (_context6.prev = _context6.next) {
        case 0:
            _context6.next = 2;
            return request.post("/api/v1/online/login/checkForgotPassword", Object.assign({}, data, { useSubmitTime: true, inlineError: true }));
        case 2:
            resp = _context6.sent;
            return _context6.abrupt("return", resp.data);
        case 4:
        case "end": return _context6.stop();
    }
} }, _callee6); })); return _checkForgotPassword.apply(this, arguments); }
export function resendAccountActivation(_x6) { return _resendAccountActivation.apply(this, arguments); }
function _resendAccountActivation() { _resendAccountActivation = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee7(data) { var resp; return _regeneratorRuntime.wrap(function _callee7$(_context7) { while (1) {
    switch (_context7.prev = _context7.next) {
        case 0:
            _context7.next = 2;
            return request.post("/api/v1/online/login/resendAccountActivation", Object.assign({}, data, { useSubmitTime: true, inlineError: true }));
        case 2:
            resp = _context7.sent;
            return _context7.abrupt("return", resp.data);
        case 4:
        case "end": return _context7.stop();
    }
} }, _callee7); })); return _resendAccountActivation.apply(this, arguments); }
export function resendSMSOTP(_x7, _x8) { return _resendSMSOTP.apply(this, arguments); } //忘記密碼  發送驗證碼
function _resendSMSOTP() { _resendSMSOTP = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee8(ticket, randStr) { var resp; return _regeneratorRuntime.wrap(function _callee8$(_context8) { while (1) {
    switch (_context8.prev = _context8.next) {
        case 0:
            _context8.next = 2;
            return request.post("/api/v1/online/login/resendSMSOTP", { sendType: "1", useSubmitTime: true, inlineError: true, ticket: ticket, randStr: randStr });
        case 2:
            resp = _context8.sent;
            return _context8.abrupt("return", resp.data);
        case 4:
        case "end": return _context8.stop();
    }
} }, _callee8); })); return _resendSMSOTP.apply(this, arguments); }
export function sendSMSOTP(_x9, _x10) { return _sendSMSOTP.apply(this, arguments); }
function _sendSMSOTP() { _sendSMSOTP = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee9(ticket, randStr) { var resp; return _regeneratorRuntime.wrap(function _callee9$(_context9) { while (1) {
    switch (_context9.prev = _context9.next) {
        case 0:
            _context9.next = 2;
            return request.post("/api/v1/online/login/sendOTP", { sendType: "2", useSubmitTime: true, inlineError: true, ticket: ticket, randStr: randStr });
        case 2:
            resp = _context9.sent;
            return _context9.abrupt("return", resp === null || resp === void 0 ? void 0 : resp.data);
        case 4:
        case "end": return _context9.stop();
    }
} }, _callee9); })); return _sendSMSOTP.apply(this, arguments); }
export function checkSMSOTP(_x11) { return _checkSMSOTP.apply(this, arguments); }
function _checkSMSOTP() { _checkSMSOTP = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee10(data) { var _data$sendType; var resp; return _regeneratorRuntime.wrap(function _callee10$(_context10) { while (1) {
    switch (_context10.prev = _context10.next) {
        case 0:
            _context10.next = 2;
            return request.post("/api/v1/online/login/checkSmsOTPCode", { otpCode: data.otpCode, sendType: (_data$sendType = data.sendType) !== null && _data$sendType !== void 0 ? _data$sendType : "1", referUrl: data.referUrl, useSubmitTime: true, inlineError: true });
        case 2:
            resp = _context10.sent;
            return _context10.abrupt("return", resp.data);
        case 4:
        case "end": return _context10.stop();
    }
} }, _callee10); })); return _checkSMSOTP.apply(this, arguments); }
export function resetPassword(_x12) { return _resetPassword.apply(this, arguments); }
function _resetPassword() { _resetPassword = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee11(data) { var resp; return _regeneratorRuntime.wrap(function _callee11$(_context11) { while (1) {
    switch (_context11.prev = _context11.next) {
        case 0:
            _context11.next = 2;
            return request.post("/api/v1/online/login/resetPassword", { pwd: data.password ? md5(data.password) : null, useSubmitTime: true, inlineError: true });
        case 2:
            resp = _context11.sent;
            return _context11.abrupt("return", resp.data);
        case 4:
        case "end": return _context11.stop();
    }
} }, _callee11); })); return _resetPassword.apply(this, arguments); }
export function newCustomerSetPassword(_x13) { return _newCustomerSetPassword.apply(this, arguments); }
function _newCustomerSetPassword() { _newCustomerSetPassword = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee12(data) { var resp; return _regeneratorRuntime.wrap(function _callee12$(_context12) { while (1) {
    switch (_context12.prev = _context12.next) {
        case 0:
            _context12.next = 2;
            return request.post("/api/v1/online/signup/newCustomerSetPassword", Object.assign({}, data, { gbdToken: data.gbdToken, pwdMD5: data.pwdMD5 ? md5(data.pwdMD5) : null, useSubmitTime: true, inlineError: true }));
        case 2:
            resp = _context12.sent;
            return _context12.abrupt("return", resp.data);
        case 4:
        case "end": return _context12.stop();
    }
} }, _callee12); })); return _newCustomerSetPassword.apply(this, arguments); }
